module.exports = "<jobbleheader></jobbleheader>\n\n<div style=\"text-align: center; margin-top: 100px\">Redirecting</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/jobdetails/jobdetails.html
// module id = 699
// module chunks = 0